import { SessionExtra } from "../../store/Session/SessionModel";
import BestShot from "../CombineScoreSection/BestShot";
import BestTarget from "../CombineScoreSection/BestTarget";
import CombineScore from "../CombineScoreSection/CombineScore";
import SkeletonLineWrapper from "../SkeletonWrapper/SkeletonLineWrapper";

interface Props {
  sessionData: SessionExtra;
}

const CombineScoreSection = ({ sessionData }: Props): JSX.Element => {
  const { drillTargets }: any = sessionData;

  if (!drillTargets || drillTargets?.length === 0) {
    return <></>;
  }
  return (
    <div className="combine-score">
      <div className="main-combine-score">
        <div className="wrap-combine-score">
          <SkeletonLineWrapper height="120px">
            <CombineScore sessionData={sessionData} />
          </SkeletonLineWrapper>
          <SkeletonLineWrapper height="120px">
            <BestTarget sessionData={sessionData} />
          </SkeletonLineWrapper>
          <SkeletonLineWrapper height="120px">
            <BestShot sessionData={sessionData} />
          </SkeletonLineWrapper>
        </div>

        <div className="power-by">
          <SkeletonLineWrapper width="100px">
            <span className="power-by-text">Powered by</span>
            <span>
              <img height={12} src="/img/combine/fs_clippd.png" alt="" />
            </span>
          </SkeletonLineWrapper>
        </div>
      </div>
    </div>
  );
};

export default CombineScoreSection;
